// Which nav item is "selected" for a pathname (M1, #374 P6 /qa).
//
// A path matches on WHOLE segments (`full` or `full/...`), never a bare prefix, and when several
// items match only the LONGEST path is active: `reports/registration-fees/weekly` must not also
// light `reports/registration-fees`, nor the Reports overview (`reports`).

/** The index route ('') is active only on the base path itself. */
function matchLength(pathname: string, basePath: string, path: string): number {
  if (path === '') return pathname === basePath ? basePath.length : -1;
  const full = `${basePath}/${path}`;
  return pathname === full || pathname.startsWith(`${full}/`) ? full.length : -1;
}

export function isNavPathActive(pathname: string, basePath: string, path: string, allPaths: readonly string[]): boolean {
  const own = matchLength(pathname, basePath, path);
  if (own < 0) return false;
  return !allPaths.some((other) => other !== path && matchLength(pathname, basePath, other) > own);
}
